import React, { useState } from "react";
import { Link } from "react-router-dom";

// --- Icon SVG Definitions (Extracted for cleaner JSX) ---

// Icone do Google
const GoogleIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M17.64 9.20454C17.64 8.56636 17.5827 7.95272 17.4764 7.36363H9V10.845H13.8436C13.635 11.97 13.0009 12.9231 12.0477 13.5613V15.8195H14.9564C16.6582 14.2527 17.64 11.9454 17.64 9.20454Z"
      fill="#4285F4"
    ></path>
    <path
      d="M9 18C11.43 18 13.4673 17.1941 14.9564 15.8195L12.0477 13.5613C11.2418 14.1013 10.2109 14.4204 9 14.4204C6.65591 14.4204 4.67182 12.8372 3.96409 10.71H0.957275V13.0418C2.43818 15.9831 5.48182 18 9 18Z"
      fill="#34A853"
    ></path>
    <path
      d="M3.96409 10.71C3.78409 10.17 3.68182 9.59318 3.68182 9C3.68182 8.40682 3.78409 7.83 3.96409 7.29V4.95818H0.957275C0.347727 6.17318 0 7.54773 0 9C0 10.4523 0.347727 11.8268 0.957275 13.0418L3.96409 10.71Z"
      fill="#FBBC05"
    ></path>
    <path
      d="M9 3.57955C10.3214 3.57955 11.5077 4.03364 12.4405 4.92545L15.0218 2.34409C13.4632 0.891818 11.4259 0 9 0C5.48182 0 2.43818 2.01682 0.957275 4.95818L3.96409 7.29C4.67182 5.16273 6.65591 3.57955 9 3.57955Z"
      fill="#EA4335"
    ></path>
  </svg>
);

// Icone de Email (Mail)
const MailIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`lucide lucide-mail ${props.className}`}
  >
    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
  </svg>
);

// Icone de Senha (Lock)
const LockIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`lucide lucide-lock ${props.className}`}
  >
    <rect width="18" height="11" x="3" y="11" rx="2" ry="2"></rect>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
  </svg>
);

// Icone de Olho (Eye)
const EyeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`lucide lucide-eye ${props.className}`}
  >
    <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

// Icone de Chave (Key Round)
const KeyRoundIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`lucide lucide-key-round ${props.className}`}
  >
    <path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z"></path>
    <circle cx="16.5" cy="7.5" r=".5" fill="currentColor"></circle>
  </svg>
);

// --- Main Component ---

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleGoogleLogin = () => {
    console.log("Login com Google acionado!");
    // Lógica de autenticação com Google aqui
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("userToken", email);
  };

  const handleForgotPassword = () => {
    console.log("Esqueceu a senha? acionado!");
    // Lógica de recuperação de senha aqui
  };

  const handleCreateAccount = () => {
    console.log("Criar conta acionado!");
    // Lógica para ir para a tela de registro
  };

  // Placeholder para o logo (substituindo o asset indisponível)
  const LogoPlaceholder = () => (
    <a className="inline-flex items-center gap-2 mb-4" href="/"></a>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md animate-fade-in-up">
        <div className="text-center mb-8">
          {/* Substituição do asset da imagem por um placeholder */}
          <LogoPlaceholder />
        </div>

        <div className="rounded-2xl border border-gray-200 bg-white text-gray-900 shadow-xl shadow-gray-200/50">
          <div className="flex flex-col p-6 space-y-1">
            <h3 className="tracking-tight text-2xl font-bold text-center">
              Entrar na sua conta
            </h3>
            <p className="text-sm text-gray-500 text-center">
              Digite suas credenciais para acessar
            </p>
          </div>

          <div className="p-6 pt-0">
            <div className="space-y-4">
              <button
                onClick={handleGoogleLogin}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border-gray-300 bg-white hover:text-gray-900 h-10 px-4 py-2 rounded-xl w-full relative border-2 hover:bg-gray-50 hover:border-blue-500/50 transition-all shadow-sm"
              >
                <GoogleIcon />
                <span className="ml-2">Entrar com Google</span>
              </button>

              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div
                    role="none"
                    className="shrink-0 bg-gray-200 h-[1px] w-full"
                  ></div>
                </div>
                <div className="relative flex justify-center text-xs uppercase">
                  <span className="bg-white px-2 text-gray-500">
                    Ou continue com email
                  </span>
                </div>
              </div>
            </div>

            <form className="space-y-4 mt-4" onSubmit={handleSubmit}>
              <div className="space-y-2">
                <label
                  className="text-sm font-medium leading-none flex items-center gap-2 text-gray-700"
                  htmlFor="email"
                >
                  <MailIcon className="h-4 w-4 text-gray-500" />
                  Email
                </label>
                <input
                  type="email"
                  className="flex h-10 w-full min-w-0 max-w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-base placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm pl-3 transition-colors"
                  id="email"
                  placeholder="seu@email.com"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="space-y-2">
                <label
                  className="text-sm font-medium leading-none flex items-center gap-2 text-gray-700"
                  htmlFor="password"
                >
                  <LockIcon className="h-4 w-4 text-gray-500" />
                  Senha
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="flex h-10 w-full min-w-0 max-w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-base placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm pr-10 transition-colors"
                    id="password"
                    placeholder="••••••••"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 p-1 rounded-full transition-colors"
                    aria-label={
                      showPassword ? "Ocultar senha" : "Mostrar senha"
                    }
                  >
                    <EyeIcon className="h-4 w-4" />
                  </button>
                </div>
              </div>

              <div className="text-right">
                <button
                  type="button"
                  onClick={handleForgotPassword}
                  className="text-sm text-blue-600 hover:underline inline-flex items-center gap-1 transition-colors"
                >
                  <KeyRoundIcon className="h-3 w-3" />
                  Esqueceu a senha?
                </button>
              </div>

              <button
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-gradient-primary text-primary-foreground hover:shadow-glow transition-all duration-300 h-12 rounded-2xl px-8 text-base w-full"
                type="submit"
              >
                Entrar
              </button>
            </form>

            <div className="mt-6 text-center text-sm">
              <span className="text-gray-500">Não tem uma conta?</span>{" "}
              <button
                type="button"
                onClick={handleCreateAccount}
                className="text-blue-600 hover:underline font-medium transition-colors"
              >
                Criar conta
              </button>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <Link
            className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
            to="/"
          >
            ← Voltar para início
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
